export default __webpack_public_path__ + "static/media/DeveloperSupport_general_cloud_support_process_create_new_inc.6f1520a8.png";